import angular from 'angular';
import uiRouter from 'angular-ui-router';
import SubscriptionComponent from './subscription.component';
import routing from './subscription.routes';

export default angular
  .module('verifyApp.subscription', [uiRouter])
  .config(routing)
  .component('subscription', SubscriptionComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/subscription/index.js